var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbag4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 5.80723H4.78596C3.71605 5.80723 2.83054 6.6383 2.7638 7.70507L2.71362 8.50716L7.78813 12.0558C10.317 13.8243 13.683 13.8243 16.2119 12.0558L21.2864 8.50716L21.2362 7.70507C21.1694 6.6383 20.2839 5.80723 19.214 5.80723H16.812C16.812 3.15227 14.6576 1 12 1C9.3424 1 7.188 3.15227 7.188 5.80723ZM8.70758 5.80723C8.70758 3.99068 10.1816 2.51807 12 2.51807C13.8183 2.51807 15.2924 3.99068 15.2924 5.80723H8.70758Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 13.2995L21.3974 10.2825L21.996 19.8496C22.0689 21.0149 21.1425 22 19.9738 22H4.02618C2.85748 22 1.93113 21.0149 2.00403 19.8496L2.60256 10.2825L6.91672 13.2995C9.96883 15.4338 14.0312 15.4338 17.0833 13.2995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag4);
export default __webpack_public_path__ + "static/media/handbag-4.b62278edf8aefa334ae976637b42d937.svg";
export { ForwardRef as ReactComponent };